export const steps = [
  "GitHub Details",
  "Payment Step",
  "Adding To GitHub Repo",
];
